import React from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from "../Images/haveli-logo.png";

function MainNav() {
    return (
        <div className='main-navbar-wraper'>
            <Navbar expand="lg" className="navbar-custom sticky-navbar">
                <Container>
                    <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
                        <img className='logo' src={logo} alt="Haveli Restaurant Logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="navbar-nav" />
                    <Navbar.Collapse id="navbar-nav">
                        <Nav className="mx-auto align-items-lg-center">
                            <Nav.Link as={Link} to="/" className="nav-link-custom">Home</Nav.Link>

                            {/* Dining Experience Dropdown */}
                            <NavDropdown 
                                title={<Link to="/dining-experience" className='dropdown-title'>Dining Area</Link>} 
                                id="dining-dropdown" 
                                className="dropdown-custom"
                            >
                                <NavDropdown.Item as={Link} to="/open-sky" className="dropdown-item-custom">Open to Sky</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/haveligarden" className="dropdown-item-custom">Haveli Garden</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/verandha" className="dropdown-item-custom">Verandah (Indoor Area)</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/baroodkhana" className="dropdown-item-custom">Barood Khana</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/musem" className="dropdown-item-custom">Museum</NavDropdown.Item>
                            </NavDropdown>

                            {/* Club & Chambers Dropdown */}
                            <NavDropdown 
                                title={<Link to="/club" className='dropdown-title'>Haveli Club</Link>} 
                                id="club-dropdown" 
                                className="dropdown-custom"
                            >
                                <NavDropdown.Item as={Link} to="/sultanroom" className="dropdown-item-custom">Sultanate Room</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/khalsaroom" className="dropdown-item-custom">Khalsa Room</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/mughal" className="dropdown-item-custom">Mughal Room</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/raj" className="dropdown-item-custom">Raj Room</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/sammr" className="dropdown-item-custom">Sammar Palace</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link as={Link} to="/gellary" className="nav-link-custom">Gallery</Nav.Link>

                            {/* Events Dropdown */}
                            <NavDropdown 
                                title={<Link to="/event" className='dropdown-title'>Events</Link>} 
                                id="events-dropdown" 
                                className="dropdown-custom"
                            >
                                <NavDropdown.Item as={Link} to="/birthday" className="dropdown-item-custom">Birthday Celebration</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/nikha" className="dropdown-item-custom">Nikkah Ceremony</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/corporateevent" className="dropdown-item-custom">Corporate Events</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/offpremises" className="dropdown-item-custom">Off Premises Catering</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/citytours" className="dropdown-item-custom">Walled City Tours</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/catering" className="dropdown-item-custom">Buffet &amp; Catering Info</NavDropdown.Item>
                            </NavDropdown>

                            {/* About Us Dropdown */}
                            <NavDropdown 
                                title={<Link to="/about" className="dropdown-title">About Us</Link>} 
                                id="about-dropdown" 
                                className="dropdown-custom"
                            >
                                <NavDropdown.Item as={Link} to="/our-history" className="dropdown-item-custom">Our History</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/mission-vision" className="dropdown-item-custom">Mission &amp; Vision</NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/our-team" className="dropdown-item-custom">Meet the Team</NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link as={Link} to="/menu" className="nav-link-custom">Menu</Nav.Link>
                            <Nav.Link as={Link} to="/contact" className="nav-link-custom">Contact</Nav.Link>
                            <Nav.Link as={Link} to="/contact" className="nav-cta-btn ms-lg-2">
                                <span>Reserve Table</span>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
}

export default MainNav;
